import Types from 'pages/workouts/util/Types';

const WorkoutOptions = {
    AutoAddRestStepAfterSteps: false,
    CanDeleteStepsInsideRepeater: true,
    CanSortStepsInsideRepeater: true,
    MaxSteps: 100,
    DefaultRepeatIteration: 2,
    LabelAddRepeat: 'workout.add.repeat'
};

/**
 * Backbone Reference: getStepSelectOptions().StepType in backbone/pages/workouts/workoutConfig/RunningWorkoutV2.js
 */
const getStepTypeSelectionItems = () => [
    {
        value: Types.StepTypes.Warm_Up,
        textKey: 'workout:workout.stepType.warmup'
    },
    {
        value: Types.StepTypes.Interval,
        textKey: 'workout:workout.run'
    },
    {
        value: Types.StepTypes.Recovery,
        textKey: 'workout:workout.stepType.recovery'
    },
    {
        value: Types.StepTypes.Rest,
        textKey: 'workout:workout.stepType.rest'
    },
    {
        value: Types.StepTypes.Cool_Down,
        textKey: 'workout:workout.stepType.cooldown'
    },
    {
        value: Types.StepTypes.Other,
        textKey: 'workout:workout.step.type.other'
    }
];

/**
 * Backbone Reference: getStepSelectOptions().Duration in backbone/pages/workouts/workoutConfig/RunningWorkoutV2.js
 */
const getDurationTypeSelectionItems = () => [
    {
        value: Types.ConditionTypes.Time,
        textKey: 'units:label_time'
    },
    {
        value: Types.ConditionTypes.Distance,
        textKey: 'units:label_distance'
    },
    {
        value: Types.ConditionTypes.Lap_Button,
        textKey: 'workout:workout.step.duration.type.lap.button'
    },
    {
        value: Types.ConditionTypes.Calories,
        textKey: 'units:label_calories'
    },
    {
        value: Types.ConditionTypes.Heart_Rate,
        textKey: 'units:label_heart_rate'
    }
];

const getTargetTypeSelectionItems = (showPowerTarget) => {
    const items = [
        {
            value: Types.TargetTypes.No_Target,
            textKey: 'workout:workout_step_target_no_target_label'
        },
        {
            value: Types.TargetTypes.Pace_Zone,
            textKey: 'units:label_pace'
        },
        {
            value: Types.TargetTypes.Cadence,
            textKey: 'units:label_cadence'
        },
        {
            value: Types.ChildTargetTypes.Select_Heart_Rate_Zone,
            textKey: 'workout:select_heart_rate_zone_label'
        },
        {
            value: Types.TargetTypes.Heart_Rate_Zone,
            textKey: 'workout:custom_heart_rate_label'
        }
    ];

    if (showPowerTarget) {
        items.push(
            ...[
                {
                    value: Types.ChildTargetTypes.Select_Power_Zone,
                    textKey: 'workout:power_zone_label'
                },
                {
                    value: Types.TargetTypes.Power_Zone,
                    textKey: 'workout:custom_power_zone_label'
                }
            ]
        );
    }

    return items;
};

const RepeatOptions = {
    [Types.RepeatTypes.Iterations]: {
        type: Types.ConditionTypes.Iterations,
        value: Types.RepeatTypes.Iterations,
        text: 'workout.number.of.times',
        unit: 'workout.repeat.title.times',
        min: 2,
        max: 40,
        defaultValue: 2
    }
};

const getPowerZoneGroupOptions = () => {};

export default {
    WorkoutOptions,
    getStepTypeSelectionItems,
    getTargetTypeSelectionItems,
    getDurationTypeSelectionItems,
    RepeatOptions
};
